import { render, staticRenderFns } from "./agentCard.vue?vue&type=template&id=89fcf422&"
import script from "./agentCard.vue?vue&type=script&lang=js&"
export * from "./agentCard.vue?vue&type=script&lang=js&"
import style0 from "./agentCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports